import { createSelector } from 'reselect';
import { myLoadInitialState } from './../../reducers/myload/reducer';

export const selectData = (state: any) => state.myload || myLoadInitialState;

const getIdParam = (_state: any, props: any) => {
  return props && props.match && props.match.params && props.match.params['id'];
};
const getModule = (_state: any, props: any) => {
  return props && props.match && props.match.params && props.match.params[0];
};

export const makeMyLoadCardData = () =>
  createSelector(
    [selectData],
    myload => myload.myLoadCardData || myLoadInitialState.myLoadCardData
  );

export const getCount = () =>
  createSelector([selectData], myload => {
    return myload.myLoadCount;
  });
export const getDriverCountForManageUsers = () =>
  createSelector([selectData], myload => {
      return myload.totalShipmentsCount;
    });
export const getMyLoadsFilteredCount = () =>
  createSelector([selectData], myload => {
    return myload.myLoadFilterCount;
  });

export const getLoadData = () =>
  createSelector([selectData], myload => {
    return {
      carrierLoad: myload.carrierAssigned || [],
      driverLoad: myload.driverAssigned || [],
      inTransitLoad :  myload.inTransit || [],
      deliveredNeedsPPWKLoad: myload.deliveredNeedsPaperWork || [],
      carrierTenderedLoad :myload.carrierTendered || [],
    };
  });

export function getDriverAssignedLoads() {
  return createSelector([selectData], myload => {
    return myload.driverAssigned || [];
  });
}

export function getCarrierAssignedLoads() {
  return createSelector([selectData], myload => {
    return myload.carrierAssigned || [];
  });
}

export function getInTransitLoads() {
  return createSelector([selectData], myload => {
    return myload.inTransit || [];
  });
}

export function getRecentDeliveredLoads() {
  return createSelector([selectData], myload => {
    return myload.deliveredNeedsPaperWork || [];
  });
}
export function getDeliveredWithPPWKLoads() {
  return createSelector([selectData], myload => {
    return myload.deliveredWithPaperWork || [];
  });
}

export const getCarrierLoad = () =>
  createSelector(selectData, getIdParam, getModule, (loaddata, id, module) => {
    if (module === 'MyLoad/CarrierAssigned') {
      return (
        (loaddata &&
          loaddata.carrierAssigned.find((x: any) => x.shipmentId === id)) ||
        {}
      );
    } 
    else if (module === 'MyLoad/CarrierTendered') {
      return (
        (loaddata &&
          loaddata.carrierTendered.find((x: any) => x.shipmentId === id)) ||
        {}
      );
    }else if (module === 'MyLoad/DriverAssigned') {
      return (
        (loaddata &&
          loaddata.driverAssigned.find((x: any) => x.shipmentId === id)) ||
        {}
      );
    } else if (module === 'MyLoad/InTransit') {
      return (
        (loaddata &&
          loaddata.inTransit.find((x: any) => x.shipmentId === id)) ||
        {}
      );
    } else if (module === 'MyLoad/DeliveredNeedsPPWK') {
      return (
        (loaddata &&
          loaddata.delivered.find((x: any) => x.shipmentId === id)) ||
        {}
      );
    } else if (module === 'MyLoad/shipmentUpdateScreen') {
      const data = [
        ...loaddata.driverAssigned,
        ...loaddata.inTransit,
        ...loaddata.delivered
      ];
      return (data && data.find((x: any) => x.shipmentId === id)) || {};
    }
  });

export const getConfirmStartInformation = () =>
  createSelector([selectData], myload => (myload && myload.confirmStart) || {});

export const getStartTripShipmentStatusMessage = () =>
  createSelector(selectData, shipmentData => {
    return shipmentData && shipmentData.confirmStartStatusMessage;
  });

  export const getStartTripShipmentDetails = () =>
  createSelector(selectData, shipmentData => {
    return shipmentData && shipmentData.startTrip;
  });

export const getBookLoadStatus = () =>
  createSelector(selectData, BuyLoad => BuyLoad.buy || {});

export const getShipmentDetails = () =>
  createSelector(selectData, getShipment => {
    let obj = {};
    if (getShipment.shipment.length > 0) {
      obj = {
        shipments: getShipment.shipment,
        hasShipment: true
      };
    }
    return obj;
  });

export const buyloadShipmentStatus = () =>
  createSelector(
    selectData,
    clearResponse => clearResponse.buyLoadResponseStatus
  );

export const getWarningDialogMessage = () =>
  createSelector(
    [selectData],
    myload =>
      myload.warningDialogMessage || myLoadInitialState.warningDialogMessage
  );
export const updateStopInfo = () =>
  createSelector(selectData, myload => (myload && myload.updateStop) || {});

export const isShipmentsAvailable = () =>
  createSelector([selectData], myload => {
    return ((myload.carrierAssigned?.length || myload.driverAssigned?.length) || (myload.inTransit?.length || myload.delivered?.length)) || 0;
  });